import {
  App
} from './.request-address.js'


  /**
   * 获取摄像头token
   * */
  export function getToken(baseurl) {
    const app = new App(baseurl)
    return app.request({
      method: 'get'
    })
  }


  //  export function getToken(token) {
  //   return request({
  //     url: `/ys7/${token}`,
  //     method: 'get',
  //   })
  // }




// WEBPACK FOOTER //
// ./src/api/camera.js